module.exports = __webpack_public_path__ + "static/media/headset5.ebe090e6.svg";